// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination{margin:5px 10px}", "",{"version":3,"sources":["webpack://./widget/tint/theme/src/components/pagination/pagination.sass"],"names":[],"mappings":"AAAA,YACE,eAAA","sourcesContent":[".pagination\n  margin: 5px 10px"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
